var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.97427V24.0243C11.75 24.8243 11.0125 25.4243 10.2375 25.2493C4.65 23.9993 0.5 18.9868 0.5 12.9993C0.5 7.01177 4.65 1.99927 10.2375 0.749271C11.0125 0.574271 11.75 1.17427 11.75 1.97427ZM14.2875 1.97427V10.4868C14.2875 11.1743 14.85 11.7368 15.5375 11.7368H24.025C24.825 11.7368 25.425 10.9993 25.25 10.2118C24.1875 5.51177 20.5 1.81177 15.8125 0.749271C15.025 0.574271 14.2875 1.17427 14.2875 1.97427ZM14.2875 15.5118V24.0243C14.2875 24.8243 15.025 25.4243 15.8125 25.2493C20.5125 24.1868 24.2 20.4743 25.2625 15.7743C25.4375 14.9993 24.825 14.2493 24.0375 14.2493H15.55C14.85 14.2618 14.2875 14.8243 14.2875 15.5118Z",
    fill: "#FFB142"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.fc5dbd75.svg";
export { ForwardRef as ReactComponent };